import { stringify } from "querystring"

import { Navigate } from "react-router-dom"

import { createPath } from "modules/ClientAccount/utils"

export const AUTH_PAGE = createPath("/authorization")

function authRedirectUrl() {
    const next = document.location.href.replace(document.location.origin, "")
    if (AUTH_PAGE.includes(next)) return AUTH_PAGE
    return `${AUTH_PAGE}?${stringify({ next })}`
}

export function RedirectToAuth() {
    return <Navigate to={authRedirectUrl()} replace />
}
